import {Typography} from '@mui/material';
import MarkdownContentRenderer from '../../../atoms/MarkdownContentRenderer/MarkdownContentRenderer';

export interface AdminQuestionReviewQuestionTextProps {
  questionText: string;
}

export default function AdminQuestionReviewQuestionText({questionText}: AdminQuestionReviewQuestionTextProps) {
  return (
    <Typography variant="h6" sx={{fontWeight: 500}}>
      <MarkdownContentRenderer content={questionText} />
    </Typography>
  );
}
